import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import api from "@/lib/api";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function StockTicker() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    const fetchData = () => {
      api.get("/stock/index")
        .then((res) => mounted && setData(res.data))
        .catch(() => {});
    };
    fetchData();
    const id = setInterval(fetchData, 60000);
    return () => { mounted = false; clearInterval(id); };
  }, []);

  const movers = data?.movers || [];

  return (
    <div data-testid="stock-ticker" className="ticker-row text-bone py-3 border-y border-white/5 relative overflow-hidden">
      <Marquee speed={45} gradient={false} pauseOnHover>
        <div className="marquee-text font-mono text-xs tracking-wide pr-12">
          {movers.length === 0 && (
            <span className="opacity-60">PSE Live Feed · loading market data…</span>
          )}
          {movers.map((m, i) => {
            const change = parseFloat(m.percent_change ?? 0);
            const positive = change >= 0;
            return (
              <span key={`${m.symbol}-${i}`} className="inline-flex items-center gap-2">
                <span className="overline text-gold text-[0.65rem]">{m.symbol}</span>
                <span className="opacity-80">{m.name}</span>
                <span className="font-medium">₱{Number(m.price).toLocaleString(undefined, { maximumFractionDigits: 2 })}</span>
                <span className={`inline-flex items-center gap-1 ${positive ? "text-emerald-300" : "text-red-300"}`} style={{ color: positive ? "#86efac" : "#fca5a5" }}>
                  {positive ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                  {positive ? "+" : ""}{change.toFixed(2)}%
                </span>
                <span className="opacity-30">•</span>
              </span>
            );
          })}
        </div>
      </Marquee>
    </div>
  );
}
